import type {
    DropdownData,
} from '@fitogest/reactive-form-builder/interfaces';
import { list } from '@fitogest/reactive-form-builder/utils';
import { ClienteModel } from 'src/app/models/cliente.model';
import { SectorModel } from 'src/app/models/form-common/sector.model';
import { ParcelasModel } from 'src/app/models/form-common/parcelas.model';
import { FincasModel } from 'src/app/models/form-common/fincas.module';
import { ProductosModel } from 'src/app/models/productos/productos.model';
import { MantenimientoModel } from 'src/app/models/trabajadores/mantenimiento.model';
import { MaquinariaModel } from 'src/app/models/trabajadores/maquinaria.model';
import { UserModel } from 'src/app/models/usuarios/user.model';

export class FertilizantesListsDefinition {
    public fincas: DropdownData<FincasModel> = list<FincasModel>();
    
    public sectores: DropdownData<SectorModel> = list<SectorModel>();
    
    public parcelas: DropdownData<ParcelasModel> = list<ParcelasModel>();
    
    public trabajadores: DropdownData<MantenimientoModel> = list();
    
    public users: DropdownData<UserModel> = list();

    public maquinarias: DropdownData<MaquinariaModel> = list();
    
    public tipo_fertilizacion: DropdownData<string> = list(
        ['...', null],
        'Abono foliar',
        'Abono de cobertera',
        'Abono de fondo',
        'Fertirrigación'
    );
    
    public tipo_fertilizacion_covidai: DropdownData<string> = list(
        ['...', null],
        'Foliar',
        'Abono foliar',
        'Abono de cobertera',
        'Abono de fondo',
        'Fertirrigación',
        'Otros'
    );
    
    public buenasPracticasFertilizantes: DropdownData<string> = list();
          
    public metodosAplicacionFertis: DropdownData<string> = list();
    
    public tiposFertilizacionSIEX: DropdownData<string> = list();
        
    public estadoTareas: DropdownData<string> = list(
        ['...', null],
        'Orden de Trabajo',
        'Parte de Trabajo'
    );
        
    public weekDays: DropdownData<string> = list(
        'L',
        'M',
        'X',
        'J',
        'V',
        'S',
        'D'
    );
    
    public clientes: DropdownData<ClienteModel> = list();

    public productos: DropdownData<ProductosModel> = list();
        
    public prioridades: DropdownData<string> = list(
        ['...', null],
        'Alta',
        'Realizada'
    );
}